// UnauthenticatedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const UnauthenticatedRoute = ({ children, redirectTo = "/" }) => {
  const { isAuthenticated } = useAuth();
  const { search, pathname } = useLocation();
  // If the URL carries a fresh login intent (restaurant switch, invite token,
  // or the super-admin login page) let the page handle it instead of bouncing
  // back to the cached session.
  const params = new URLSearchParams(search);
  const hasLoginIntent =
    params.has("restaurant_name") ||
    params.has("token") ||
    pathname === "/super-admin/login";

  if (isAuthenticated && !hasLoginIntent) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default UnauthenticatedRoute;
